import type { PageContextServer } from 'vike/types';
import { parseAcceptLanguage, getCookieValue, type Locale } from '@/lib/shared';

export function onBeforeRoute(pageContext: PageContextServer) {
  const urlOriginal = pageContext.urlOriginal || '';
  const url = new URL(urlOriginal, 'http://localhost');
  const match = url.pathname.match(/^\/(en|sv)(\/.*)?$/);

  if (match) {
    const locale = match[1] as Locale;
    const internalPath = match[2] || '/';
    return {
      pageContext: {
        locale,
        urlLocalePathname: url.pathname + url.search,
        // Keep the query: routing matches on the pathname, but pages like
        // /mailing/:id/confirm_unsubscribe need the search params.
        urlLogical: internalPath + url.search,
      },
    };
  }

  // Fallback for requests without a locale prefix. Reachable in local dev,
  // where `pnpm dev` is plain `vite` and the Express middleware
  // (server/middleware/locale.ts) never runs. In production the middleware
  // redirects these before Vike sees them, so this branch is dev-only.

  // Read lang cookie first; if valid Locale, use it. Then parseAcceptLanguage.
  const cookieHeader = (pageContext.headersOriginal as Record<string, string> | undefined)?.cookie;
  const cookieLang = getCookieValue(cookieHeader, 'lang');
  const acceptLang =
    (pageContext.headersOriginal as Record<string, string> | undefined)?.['accept-language'] || '';

  const locale: Locale =
    cookieLang === 'sv' || cookieLang === 'en'
      ? (cookieLang as Locale)
      : parseAcceptLanguage(acceptLang);

  return {
    pageContext: {
      locale,
      urlLocalePathname: `/${locale}${url.pathname === '/' ? '' : url.pathname}${url.search}`,
      urlLogical: url.pathname + url.search,
    },
  };
}
